<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Регистрация
    p.modal__text
    .modal__form
      form
        .form
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.email }"
            )
              .form-elem__title Email
              .form-elem__main
                input(
                type="email"
                v-model="userCredentials.email"
                @keyup="resetError('email')"
                ).input.input_full
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.password || userCredentialErrors.differentPasswords }"
            )
              .form-elem__title Пароль
              .form-elem__main
                input(
                type="password"
                v-model="userCredentials.password"
                @keyup="resetError('password')"
                ).input.input_full
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.password2 || userCredentialErrors.differentPasswords }"
            )
              .form-elem__title Пароль еще раз
              .form-elem__main
                input(
                type="password"
                v-model="userCredentials.password2"
                @keyup="resetError('password2')"
                ).input.input_full
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': userCredentialErrors.consent }"
            )
              .form-elem__main
                .input-item
                  .input-item__input
                    label.checkbox
                      input.checkbox__input(
                      type="checkbox"
                      v-model="userCredentials.consent"
                      @change="resetError('consent')"
                      )
                      .checkbox__icon
                  .input-item__body
                    .input-item__text Даю свое согласие на&#32;
                      a(
                      href="/docs/Согласие_на_обработку_данных_участника.docx"
                      target="_blank"
                      ).link обработку персональных данных согласно ФЗ-152
          .form__elem
            .form-elem
              .form-elem__main
                button.button.button_paint-main.button_full(
                  :class="{ 'loaded-button': pending }"
                  @click.prevent="onReg"
                )
                  .button__text Зарегистрироваться
              .form-elem__error(
                v-if="currentErrorMessage.length > 0"
              ) {{ currentErrorMessage }}
    .modal__links.modal-links
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-in')"
        ) Вход на сайт
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "sign-up",
  data() {
    return {
      pending: false,
      userCredentials: {
        email: "",
        password: "",
        password2: "",
        consent: false,
      },
      userCredentialErrors: {
        email: false,
        password: false,
        password2: false,
        consent: false,
      },
      errorMessages: {
        email: "Неверный формат email",
        password: "Пароль должен содержать минимум 8 символов",
        password2: "Пароль не совпадает",
        consent: "Необходимо согласие",
      },
      currentErrorMessage: "",
    };
  },
  methods: {
    ...mapActions(["reg"]),
    resetError(model) {
      this.userCredentialErrors[model] = false;
      this.currentErrorMessage = "";
    },
    onReg() {
      this.pending = true;
      let errors = [];
      let emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.userCredentials.email.length === 0 ||
        !emailReg.test(this.userCredentials.email)
      ) {
        errors.push("email");
      }
      if (this.userCredentials.password.length < 8) {
        errors.push("password");
      }
      if (this.userCredentials.password2 !== this.userCredentials.password) {
        errors.push("password2");
      }
      if (!this.userCredentials.consent) {
        errors.push("consent");
      }

      if (errors.length > 0) {
        this.pending = false;
        errors.map((el) => {
          this.userCredentialErrors[el] = true;
        });
        this.currentErrorMessage = this.errorMessages[errors[0]];
        return;
      }
      this.reg({
        userCredentials: {
          email: this.userCredentials.email,
          password: this.userCredentials.password,
        },
      }).then((res) => {
        this.pending = false;
        if (res.status === 400) {
          if (res.data.email) {
            this.userCredentialErrors.email = true;
            this.currentErrorMessage = "Такой пользователь уже существует";
            return;
          }
          return;
        }
        if (res.status === 201) {
          this.$emit("changeModalMode", "notification", {
            title: "Проверьте почту",
            text: `Мы выслали ссылку для подтверждения регистрации на ${this.userCredentials.email}`,
          });
        }
      });
    },
  },
};
</script>
